import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { UtilService } from '@app/service/util.service';
import { ReportService } from '@app/service/report.service';

import * as $ from 'jquery';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-print-books-register',
  templateUrl: './print-books-register.component.html',
  styleUrls: ['./print-books-register.component.scss']
})
export class PrintBooksRegisterComponent implements OnInit {

  public dataList: any = [];
  public receptionSdate: any;
  public receptionEdate: any;

  private search: any = {
    searchField: '',
    searchText: '',
    receptionSdate: '',
    receptionEdate: '',
    officeCode: '',
    regionCode: '',
    cityCode: '',
    inspectionYn: '',
    memberNo: '',
  }

  /*******************************************************************************
    설  명 : 생성자
  *******************************************************************************/
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private utilService: UtilService,
    private toastrService: ToastrService,
    private reportService: ReportService,
  ) {
    this.setPrint(true);
  }

  /*******************************************************************************
    설  명 : 생성자
  *******************************************************************************/
  ngOnInit() {
    // 파라미터 가져오기
    this.activatedRoute.queryParams.subscribe(params => {
      this.search = ( typeof params.search == 'undefined' || params.search == '' ) ? '' : JSON.parse( decodeURIComponent(params.search) );

      this.receptionSdate = this.utilService.getDateStr( this.search.receptionSdate );
      this.receptionEdate = this.utilService.getDateStr( this.search.receptionEdate );

      this.getReceptionReportList();
    });
  }

  /*******************************************************************************
    설  명 : view 로딩 후 생성자
  *******************************************************************************/
  ngAfterViewInit() {
    var data = $(".table tbody").children();
    setTimeout (() => {
      if( typeof data[0] !== undefined ) {
        window.print();
      }
    }, 500);
  }

  /*******************************************************************************
    설  명 : 접수결과대장 상세내역 가져오기
  *******************************************************************************/
  async getReceptionReportList() {
    await this.reportService.getReceptionReportList( this.search ).then( response => {
      //console.log(response);
      if( response.ResultCode ) {
        this.dataList = response.data;
      } else {
        this.toastrService.error( response.ResultMessage, '' );
      }
    });
  }

  /*******************************************************************************
    설  명 : 프린트 설정
    입력값 : landscape(가로 출력 여부)
    리턴값 : 없음
  *******************************************************************************/
  setPrint(landscape: boolean) {
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    style.media = 'print';

    style.appendChild(document.createTextNode(landscape ? '@page { size:auto; margin: 0.5in;}' : '' ));

    head.appendChild(style);
  }

}
